import { useSelector } from "react-redux";
import useBreadCrumbs from "../../hooks/useBreadCrumbs";
import { RootState } from "../../redux/store";
import BreadCrumbs from "../BreadCrumbs/BreadCrumbs";
import { upperCase } from "lodash";
import { OfficeState } from "../../models/office.model";
import Button from "../Button/Button";

const OfficeSectionsHeader = ({ showMeta = false, showStatus = false }: { showMeta?: boolean; showStatus?: boolean }) => {
  const { currentOffice } = useSelector((state: RootState) => state.office);

  const breadCrumbs = useBreadCrumbs();
  return (
    <>
      <BreadCrumbs items={breadCrumbs} />
      {showMeta ? (
        <>
          <div className="w-full flex items-center mb-2">
            <h2 className="heading">
              {upperCase(currentOffice?.name)}
              <span
                className={`py-2 mb-2 px-4 text-base text-center p-2.5 h-10 rounded-lg self-end font-bold ${
                  currentOffice?.officeState === OfficeState.Published ? "" : "opacity-40"
                }`}
              >
                {showStatus ? (currentOffice?.officeState === OfficeState.Published ? "Published" : "Unpublished") : null}
              </span>
            </h2>
            {currentOffice?.officeState === OfficeState.Pending ? (
              <Button
                onClick={() => null}
                text={"Pending Account Verification"}
                width="fit"
                className={`py-1.5 !bg-docnote-green !border-docnote-green !text-black`}
              />
            ) : null}
          </div>
          <p className="font-medium mb-6 text-sm">
            {[currentOffice?.street, currentOffice?.street1, currentOffice?.city, currentOffice?.state, currentOffice?.zip]
              .filter(Boolean)
              .join(", ")}
          </p>
        </>
      ) : null}
    </>
  );
};

export default OfficeSectionsHeader;
